<ng-container *transloco="let t">
  <section *ngIf="showSection" class="row mb-4">
    <article
      class="col-lg-6 mb-2"
      *ngIf="
        licenses.testSupportVideo &&
        (licenses.testSupportD3to4 ||
          licenses.testSupportD4to5 ||
          licenses.testSupportD5to7v1 ||
          licenses.testSupportD5to7v2 ||
          licenses.testSupportD5to7SK)
      "
    >
      <div>
        <h5 class="mb-0 fw-bold">{{ t('support/videoGuide') }}</h5>
        <p>{{ t('support/videoGuideText') }}</p>
      </div>
      <div class="video-guide">
        <!-- HOTFIX with an image-->
        <div>
          <a href="https://vimeo.com/980583719/9ee2f9b3e9?utm_source=moje_isophi&utm_medium=web " target="_blank"
            ><img class="fb-preview" src="assets/img/support/video-tutorial-preview.jpg" [alt]="t('support/videoGuid')"
          /></a>
        </div>

        <!-- VIMEO INTEGRATION NOT SHOWING FOR SOME PEOPLE... NEEDS TO BE FIXED
        <div style="padding: 56.25% 0 0 0; position: relative" *ngIf="!licenses.testSupportD5to7v1">
          <iframe
            src="https://player.vimeo.com/video/980583719?h=9ee2f9b3e9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
            title="Videoprůvodce nástrojem iSophi"
          ></iframe>
        </div>
        <script src="https://player.vimeo.com/api/player.js"></script>
        -->

        <!-- Supporting the older version of the diagnostic tool: -->
        <div class="embed-responsive embed-responsive-16by9" *ngIf="licenses.testSupportD5to7v1 && !licenses.testSupportD5to7v2">
          <iframe
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            class="embed-responsive-item"
            frameborder="0"
            src="https://www.youtube.com/embed/w_L2BHKC2IE"
          ></iframe>
        </div>

        <div class="mt-1 text-center">{{ t('support/commentedExample') }}</div>
      </div>
    </article>
    <article class="col-lg-6 fb-group mb-0 mb-md-2 mt-5 mt-md-0" *ngIf="isKindergarten">
      <div>
        <h5 class="mb-0 fw-bold">
          <a href="https://www.facebook.com/groups/poradnastep/?ref=web_social_plugin" target="_blank">FB</a>
          {{ t('support/groupEducator') }}
        </h5>
        <p>
          {{ t('support/haveQuestion') }}
          <a href="https://www.facebook.com/groups/poradnastep/?ref=web_social_plugin" target="_blank">{{ t('support/askInGroup') }}</a>
        </p>
      </div>
      <div>
        <a href="https://www.facebook.com/groups/poradnastep/?ref=web_social_plugin" target="_blank"
          ><img class="fb-preview" src="assets/img/support/fb-group-preview.jpg" alt="FB group"
        /></a>
      </div>
    </article>
  </section>

  <section *ngIf="!showSection" class="mt-5 pb-5">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h5 class="fw-bold mb-0">
        {{ t('support/moreVideo') }}
      </h5>

      <a class="btn btn-secondary" href="https://www.youtube.com/playlist?list=PLDn4jfxt89ZQAqFQr1Wt7S9BCJxFYVcp5" target="_blank">{{
        t('support/wholeList')
      }}</a>
    </div>

    <div class="d-flex flex-wrap justify-content-center justify-content-md-between">
      <div *ngFor="let video of videos" class="video">
        <a href="{{ video.url }}" target="_blank">
          <img src="{{ video.imagePath }}" alt="{{ t('support/videoPreview') }} {{ t(tutorialsTitles[video.title]) }}" />
        </a>
      </div>
    </div>
  </section>
</ng-container>
